"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_files_html_1 = __importDefault(require("./student-files.html"));
var student_files_controller_1 = __importDefault(require("./student-files.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.studentfiles", {
        url: "/student-files/:student_id",
        controller: student_files_controller_1.default,
        controllerAs: "vm",
        template: student_files_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.studentfiles", [])
    .config(config)
    .controller("InstructorStudentFilesController", student_files_controller_1.default);
